export default __webpack_public_path__ + "static/media/paver-samples.4245a5a9.jpg";